/**
 * Interfaces para Instagram Graph API
 * Substitui o Basic Display API descontinuado
 */

export interface InstagramAuthUrlRequest {
  artistId: string;
}

export interface InstagramAuthUrlResponse {
  authUrl: string;
}

export interface InstagramConnectionStatus {
  connected: boolean;
  username?: string;
}

export type InstagramAccountType = 'BUSINESS' | 'CREATOR' | 'PERSONAL';

export interface InstagramAuthResult {
  success: boolean;
  connected?: boolean;
  mismatch?: boolean;
  accountType?: InstagramAccountType;
  username?: string;
  error?: string;
  errorCode?: string;
}

export interface InstagramAuthState {
  isLoading: boolean;
  isPolling: boolean;
  hasError: boolean;
  errorMessage: string;
  successMessage: string;
  authUrl: string | null;
  status: InstagramConnectionStatus | null;
}

export interface InstagramGraphApiError {
  code: string;
  message: string;
  type: 'TECHNICAL' | 'MISMATCH' | 'ACCOUNT_TYPE' | 'PERMISSION';
}

/**
 * Estados possíveis da autenticação Instagram
 */
export enum InstagramAuthStatusEnum {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  POLLING = 'POLLING',
  SUCCESS = 'SUCCESS',
  CANCELLED = 'CANCELLED',
  ERROR_MISMATCH = 'ERROR_MISMATCH',
  ERROR_ACCOUNT_TYPE = 'ERROR_ACCOUNT_TYPE',
  ERROR_TECHNICAL = 'ERROR_TECHNICAL',
  ERROR_PERMISSION = 'ERROR_PERMISSION',
}

/**
 * Configurações do polling
 */
export interface InstagramPollingConfig {
  intervalMs: number;
  maxAttempts: number;
  timeoutMs: number;
}

export const DEFAULT_POLLING_CONFIG: InstagramPollingConfig = {
  intervalMs: 3000, // 3 segundos - mais tempo entre tentativas
  maxAttempts: 40, // 40 tentativas = 2 minutos total
  timeoutMs: 120000, // 2 minutos timeout
};
